import { render } from "./Planes.vue?vue&type=template&id=319cf2ed&scoped=true"
import script from "./Planes.vue?vue&type=script&lang=js"
export * from "./Planes.vue?vue&type=script&lang=js"

import "./Planes.vue?vue&type=style&index=0&id=319cf2ed&lang=scss&scoped=true"

import exportComponent from "C:\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319cf2ed"]])

export default __exports__